<template>

  <div class="ui grid animated fadeIn">

    <div class="sixteen wide column">

      <div class="ui segment">
        <h4 class="ui dividing header">Observações do Responsável</h4>
        <form class="ui form">          
          <div class="fields">
            <div class="sixteen wide field">
              <span>{{ quotation.comments }}</span>
            </div>                                               
          </div>
        </form>

      </div>

    </div>

    <div class="sixteen wide column">

      <div class="ui segment" :class="{ loading: loadingMessages }" style="min-height: 175px;">
        <h4 class="ui dividing header">Histórico de Mensagens</h4>
        <button class="ui mini basic button m-b-15" @click="onNewMessage()">
          <i class="plus blue icon"></i>
          Nova mensagem
        </button>
        <p v-if="quotation.messages.length == 0" class="grey text m-t-20" style="font-size: 13px;">Nenhuma mensagem</p>        
        <div v-else class="ui relaxed divided list">          
          <div v-for="message in quotation.messages" class="item">
            <div class="content">
              <div class="m-t-15">
                <a>{{ message.fromUserName }}</a>
                <span class="ui mini label m-l-10"><i class="check blue icon"></i> {{ message.when }}</span>
              </div>
              <div class="black text m-t-12" style="font-size: 14px;" v-html="message.subject"></div> 
              <div class="grey text m-t-10" style="font-size: 13px;" v-html="message.text"></div> 
            </div>
          </div>          
        </div>
      </div>

    </div>

  </div>

</template>

<script>
  export default {
    
    props: ["quotation", "loadingMessages"],    

    methods: {

      onNewMessage() {
        this.$emit("onNewMessage")
      },
    },
  }
</script>

